import {TextField} from '@legit-health/ui';
import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function VisitIdentifier({
  onChange,
  value
}: {
  onChange: (value: string) => void;
  value: string;
}) {
  const {t} = useTranslation(['shared/common']);

  return (
    <Box>
      <TextField
        label={t('shared/common:diagnosticReport.visitIdentifier')}
        id="visitIdentifier"
        aria-describedby="visitIdentifier"
        onChange={(e) => onChange(e.target.value)}
        value={value}
      />
    </Box>
  );
}
